/**
 * Preferred display order for GWP items by Jalapeno `externalSku`.
 * Items not in this list (or missing `externalSku`) sort after known SKUs.
 */
export const GWP_ITEM_ORDER_EXTERNAL_SKUS = [
    117113, // "Dark Chocolate Covered Pretzel Pieces, 12 Oz"
    119471, // "Fudge Brownies, 12 Oz"
    122044, // "Albacore Tuna With Spanish Lemon, 3.2 Oz"
    117434, // "Caramel Sea Salt Milk Chocolate Bar, 6 Oz"
    112674, // "Kettle Chips, Original Sea Salt, 6 Oz"
    116678, // "Sparkling Water, Original, 12 Fl Oz (8 Ct)"
    119332, // "Gummy Worms, Sour, 1.8 Oz"
    119070, // "Corn Dippers, Sea Salt, 9.25 Oz"
    122523, // "Froth Bath Bomb, Avocado, 2 Pack, 7 Oz"
    122905, // "Crackers, Double Cheddar, 4.2 Oz"
];

/**
 * Filters out sold-out items and sorts the rest by `GWP_ITEM_ORDER_EXTERNAL_SKUS`.
 *
 * @param {Array<{ externalSku?: number, soldOut?: boolean }>} items - Raw GWP items from the API
 * @returns {Array} In-stock items in display order
 */
export function getSortedInStockGiftWithPurchaseItems(items) {
    const inStockItems = items.filter((item) => !item.soldOut);
    const orderMap = new Map(GWP_ITEM_ORDER_EXTERNAL_SKUS.map((sku, index) => [sku, index]));

    return [...inStockItems].sort((a, b) => {
        const aOrder = orderMap.get(a.externalSku);
        const bOrder = orderMap.get(b.externalSku);

        if (aOrder === undefined && bOrder === undefined) return 0;
        if (aOrder === undefined) return 1;
        if (bOrder === undefined) return -1;
        return aOrder - bOrder;
    });
}
